export const formatInMdl = (number: number) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "MDL" }).format(
    number
  );
